/**
 * Created by jv on 15/03/2017.
 */
const Shared = require("Sources/shared");
const utils = require("Sources/utils/utils");
const LanguageManager = require("Sources/services/languagemanager");
const LoginManager = require("Sources/services/login-manager");
const StoreServices = require("Sources/services/fundels/store-services");
const StorageController = require("Sources/services/storage-controller");

var storeShared = {};

(function(StoreShared)
{
  StoreShared.isLoggedIn = false;
  StoreShared.sessionData;

  StoreShared.init = function(callback, forceFetchSessionData)
  {
    checkUserType();

    if(StoreShared.getUserType() === "CON")
    {
      $("#store-breadcrumb-order-payment").show();
    }

    LoginManager.isLoggedIn(function(userData)
    {
      StoreShared.isLoggedIn = utils.isNotNull(userData) && userData.authenticated;

      utils.devLog("Is logged in: %s --> data: %o", StoreShared.isLoggedIn, userData);

      if(StoreShared.isLoggedIn === true)
      {
        // overwrite the current user in session (in case the login came from bibnet)
        StorageController.saveToLocal(StorageController.keys.LOGGED_IN_USER, userData);
        Shared.setPageProperties();

        $("#store-login-link").hide();
        $("#store-profile-menu").show();

        $("a[href='/store/logout']").on("click", function(e)
        {
          var originalLink = $(this).attr("href");
          e.preventDefault();

          if(StoreShared.getUserType() === "BIB")
          {
            utils.redirect(originalLink);
          }
          else
          {
            StoreShared.logout();
          }
        });
      }
    });

    setUserTypeNavigation();

    setCartQuantity(function()
    {
      if(forceFetchSessionData === true && utils.isNull(StoreShared.sessionData))
      {
        getSessionData(callback);
      }
      else if(utils.isFunction(callback))
      {
        callback();
      }
    });
  };

  StoreShared.logout = function()
  {
    LoginManager.logout(function()
    {
      utils.refreshPage();
    });
  };

  StoreShared.getUserType = function()
  {
    if(utils.isNotNull(StoreShared.sessionData) && utils.isNotNull(StoreShared.sessionData.catalog))
    {
      return StoreShared.sessionData.catalog.type;
    }
    else
    {
      return StorageController.getFromLocal(StorageController.keys.STORE_USER_TYPE);
    }
  };

  StoreShared.getUserLocale = function()
  {
    if(utils.isNotNull(StoreShared.sessionData) && utils.isNotNull(StoreShared.sessionData.catalog))
    {
      return StoreShared.sessionData.catalog.locale;
    }
    else
    {
      return StorageController.getFromLocal(StorageController.keys.STORE_USER_LOCALE);
    }
  };

  StoreShared.setBreadcrumbHighlighting = function(step)
  {
    var storeCrumbs = $(".store-breadcrumb").children();

    if(step < 0 || step > storeCrumbs.length)
    {
      return;
    }

    // if(step === storeCrumbs.length - 1)
    // {
    //   storeCrumbs.find("li a").on("click", function(e)
    //   {
    //     e.preventDefault();
    //     return false;
    //   });
    // }

    storeCrumbs.each(function(index, el)
    {
      var $el = $(el);

      if($el.hasClass("back-link"))
      {
        return;
      }

      if(index === (step - 1))
      {
        $el.addClass("active");

        $el.find("a").on("click", function(e)
        {
          e.preventDefault();
          return false;
        });
      }
      else if (index > (step - 1)/* || step === storeCrumbs.length - 1*/)
      {
        $el.addClass("disabled");
        $el.find("a").on("click", function(e)
        {
          e.preventDefault();
          return false;
        });
      }
    });
  };

  function setCartQuantity(callback)
  {
    var cartQuantityEl = $("#shopping-cart-quantity");

    if(cartQuantityEl.length)
    {
      if(utils.isNull(StoreShared.sessionData))
      {
        getSessionData(function()
        {
          cartQuantityEl.text(StoreShared.sessionData.cart.itemCount);

          if(utils.isFunction(callback))
          {
            callback();
          }
        });
      }
      else
      {
        cartQuantityEl.text(StoreShared.sessionData.cart.itemCount);

        if(utils.isFunction(callback))
        {
          callback();
        }
      }
    }
    else if(utils.isFunction(callback))
    {
      callback();
    }
  }

  function setUserTypeNavigation()
  {
    var locale = StorageController.getFromLocal(StorageController.keys.STORE_USER_LOCALE);
    var userType = StorageController.getFromLocal(StorageController.keys.STORE_USER_TYPE);

    $("#change-user-type-link").html(LanguageManager.getValueForKey("navigation.store.user_type.catalog") + getCountryFlagForUserType(locale) + getIconForUserType(userType))
    .on("click", function(e)
    {
      e.stopPropagation();
      e.preventDefault();

      var link = $(this).attr("href");

      if(StoreShared.sessionData.cart.itemCount > 0)
      {
        Shared.Dialog.showYesNoDialog("store.change_user_type.confirmation.title", "store.change_user_type.confirmation.text", function()
        {
          utils.redirect(link);
        });
      }
      else
      {
        utils.redirect(link);
      }
    });
  }

  StoreShared.getReadableLocale = function(locale)
  {
    switch(locale)
    {
      case "nl_BE":
        return LanguageManager.getValueForKey("store.user_type_selection.countries.belgium");
      case "nl_NL":
        return LanguageManager.getValueForKey("store.user_type_selection.countries.netherlands");
      default:
        return null;
    }
  };

  StoreShared.getReadableUserType = function(userType)
  {
    switch(userType)
    {
      case "BIB":
        return LanguageManager.getValueForKey("store.user_type_selection.user_types.library");
      case "SCH":
        return LanguageManager.getValueForKey("store.user_type_selection.user_types.school");
      case "AND":
        return LanguageManager.getValueForKey("store.user_type_selection.user_types.other");
      case "CON":
        return LanguageManager.getValueForKey("store.user_type_selection.user_types.consumer");
      case "LOG":
        return LanguageManager.getValueForKey("store.user_type_selection.user_types.logopedist");
      case "KND":
        return LanguageManager.getValueForKey("store.user_type_selection.user_types.daycare");
      case "PSZ":
        return LanguageManager.getValueForKey("store.user_type_selection.user_types.daycare_nl");
      default:
        return null;
    }
  };

  function getCountryFlagForUserType(locale)
  {
    switch(locale)
    {
      case "nl_BE":
        return "<i class='icon-img icon-img-flag-belgium'></i>";
      case "nl_NL":
        return "<i class='icon-img icon-img-flag-netherlands'></i>";
      default:
        return null;
    }
  }

  function getIconForUserType(userType)
  {
    switch(userType)
    {
      case "BIB":
        return "<i class='icon-img icon-img-library'></i>";
      case "SCH":
        return "<i class='icon-img icon-img-school'></i>";
      case "AND":
        return "<i class='icon-img icon-img-other'></i>";
      case "CON":
        return "<i class='icon-img icon-img-consumer'></i>";
      case "LOG":
        return "<i class='icon-img icon-img-logopaedics'></i>";
      case "KND":
        return "<i class='icon-img icon-img-daycare'></i>";
      case "PSZ":
        return "<i class='icon-img icon-img-daycare'></i>";
      default:
        return null;
    }
  }

  function checkUserType()
  {
    if(utils.getPathSection(2) === "store" && (utils.getPathSection(3) === "info" || utils.getPathSection(3) === "catalog"))
    {
      var userLocale = StorageController.getFromLocal(StorageController.keys.STORE_USER_LOCALE);
      var userType = StorageController.getFromLocal(StorageController.keys.STORE_USER_TYPE);

      var userLocaleUrl = utils.getPathSection(1);
      var userTypeUrl = urlPathToUserType(utils.getPathSection(4));

      if(utils.isNotNull(userLocaleUrl) && userLocale !== userLocaleUrl)
      {
        StorageController.saveToLocal(StorageController.keys.STORE_USER_LOCALE, userLocaleUrl);
      }

      if(utils.isNotNull(userTypeUrl) && userType !== userTypeUrl)
      {
        StorageController.saveToLocal(StorageController.keys.STORE_USER_TYPE, userTypeUrl);
      }
    }
  }

  function urlPathToUserType(path)
  {
    switch(path.toLowerCase())
    {
      case "school":
        return "SCH";
      case "library":
        return "BIB";
      case "other":
        return "AND";
      case "consumer":
        return "CON";
      case "logopaedics":
        return "LOG";
      default:
        return null;
    }
  }

  function getSessionData(callback)
  {
    StoreServices.getSessionData(
      function(data)
      {
        // Success
        StoreShared.sessionData = data;

        utils.devLog("Session data: %o", StoreShared.sessionData);

        if(utils.isFunction(callback))
        {
          callback();
        }
      },
      function(data)
      {
        // Failed
        console.error("Something went wrong trying to fetch session data");
      }
    );
  }
}(storeShared));

if(__DEVELOPMENT__)
{
  window.storeShared = storeShared;
}

module.exports = storeShared;



// WEBPACK FOOTER //
// ./app/js/store-shared.js